import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useLoaderContext } from './LoaderContext';

const RouteLoader = () => {
  const location = useLocation();

  const {
    showLoader,
    hideLoader,
  } = useLoaderContext();

  useEffect(() => {
    if (location.pathname === '/') {
      hideLoader();
      return;
    }

    showLoader();
  }, [
    location.pathname,
    showLoader,
    hideLoader,
  ]);

  return null;
};

export default RouteLoader;